const YthOptions = (() => {
    $('#options_dt').DataTable({
        processing: true,
        serverSide: true,
        ajax: "/admin/options/list",
        columns: [
            {data: 'option_value', name: 'option_value'},
            {data: 'option_type', name: 'option_type'},
            {data: 'status', name: 'status'},
            {
                data: 'action', 
                name: 'action',
                orderable: true, 
                searchable: true
            },
        ]
    });

    //delete options
    $(document).on('click', '#delete-option', function (event) {
        const id = $(event.currentTarget).data('id');
        var option_id = $(this).data("id");

        Swal.fire({
            icon: 'error',
              title: 'Do you want to delete?',
              showCancelButton: true,
              confirmButtonText: 'Delete',
              denyButtonText: `Cancel`,
            }).then((result) => {
              if (result.isConfirmed) {
                  $.ajax({
                      type: "POST",
                      data: {_method: 'delete'},
                      url: baseUrl + "/admin/options/"+id,
                      success: function (data) {
                          var oTable = $('#options_dt').dataTable();
                          oTable.fnDraw(false);
                          Swal.fire(data.message, '', 'success');
                      },
                      error: function (data) {
                          Swal.fire(data.responseJSON.message, '', 'error');
                      }
                  });
                
              } else if (result.isDenied) {
                Swal.fire('Changes are not saved', '', 'info')
              }
            });
    }); 


    $( document ).ready(function() {
        // alert("here"); 
        // call validation  function etc
    });

});

export default YthOptions;
